module.exports = __webpack_public_path__ + "img/default.5af96589.jpg";